import React, { useState } from "react";
import { Select } from "components/common";
import ReceiveTable from "./tables/ReceiveTable";
import ConsumeTable from "./tables/ConsumeTable";
import SentTable from "./tables/SentTable";
import { Wrapper } from "./LogSubPage.styled";

export default function LogSubPage(props) {
  const [showTableFor, setShowTableFor] = useState("receive");
  return (
    <Wrapper>
      <div className="container-box">
        <div className="header d-flex align-items-center justify-content-between">
          <div className="title">Gift Wallet Logs</div>
          <div className="date-picker">
            <Select
              value={showTableFor}
              onChange={(val) => setShowTableFor(val)}
              options={[
                {
                  label: "Received Histories",
                  value: "receive",
                },
                {
                  label: "Purchased Histories",
                  value: "consume",
                },
                {
                  label: "Sent Histories",
                  value: "sent",
                },
              ]}
            />
          </div>
        </div>
        <div className="table-container">
          {showTableFor === "receive" && <ReceiveTable/>}
          {showTableFor === "consume" && <ConsumeTable/>}
          {showTableFor === "sent" && <SentTable shouldLoad={props.shouldLoad}/>}
        </div>
      </div>
    </Wrapper>
  );
}
